import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function StoryDetail() {
  const { slug } = useParams();
  const [story, setStory] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/stories/${slug}`).then((r) => setStory(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="mx-auto max-w-3xl px-4 py-32 text-center"><p className="eyebrow">404</p><h1 className="mt-3 font-display text-4xl font-bold text-white">Story not found</h1></div>;
  if (!story) return <div className="flex min-h-[50vh] items-center justify-center font-mono text-xs tracking-[0.3em] text-brand-cyan">LOADING...</div>;

  return (
    <article data-testid="story-detail-page">
      <div className="relative h-[45vh] overflow-hidden">
        <img src={story.image} alt={story.title} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/40 to-transparent" />
      </div>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <Link to="/stories" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] text-brand-cyan hover:gap-3 transition-all"><ArrowLeft size={14} /> ALL STORIES</Link>
        <p className="eyebrow mt-8">{story.category} — {story.date}</p>
        <h1 className="mt-3 font-display text-4xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">{story.title}</h1>
        <p className="mt-5 border-l-2 border-brand-olive pl-5 text-lg italic leading-relaxed text-slate-300">{story.excerpt}</p>
        <div className="mt-8 space-y-5">
          {story.content?.split("\n\n").map((p, i) => (
            <p key={i} className="leading-relaxed text-slate-300">{p}</p>
          ))}
        </div>
      </div>
    </article>
  );
}
